import React, { useEffect } from "react";
import { useObserver } from "mobx-react-lite";

import { UserPageHeader } from "./UserPageHeader";
import { UserPageHeaderText } from "./UserPageHeaderText";
import { UserPageExplanationControl } from "./UserPageExplanationControl";
import { UserPageDescriptionControl } from "./UserPageDescriptionControl";

import { UserPageBreadcrumb } from "./UserPageBreadcrumb";
import { UserAccessControl } from "./UserAccessControl";
import { UserPageDetails } from "./UserPageDetails";

export const UserPage: React.FunctionComponent = () => {
    //useEffect below only gets run on initial render
    useEffect(() => {
        // *optional* passing the router into the viewmodel so we can navigate from there
        console.log("First render");
        //This gets run when the page is exited
        return () => {
            console.log("Unmounting user access control");
        };
    }, []);

    return useObserver(() => (
        <UserAccessControl>
            <UserPageHeader>
                <UserPageHeaderText>
                    <div className="quickquote">Quick, accurate quotes</div>
                </UserPageHeaderText>
            </UserPageHeader>
            <UserPageBreadcrumb />
            <UserPageDescriptionControl />
            <UserPageDetails />
        </UserAccessControl>
    ));
};
